/**
 * TaskProgressStageService
 * Service for TaskProgressStage entity operations
 * Route: api/task-progress-stage
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskProgressStageService
 * Handles task progress stage CRUD operations
 */
export class TaskProgressStageService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskProgressStageService.DEFAULT_SERVICE_PATH,
            basePath: TaskProgressStageService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
TaskProgressStageService.DEFAULT_SERVICE_PATH = 'tasks';
TaskProgressStageService.BASE_PATH = 'api/task-progress-stage';
//# sourceMappingURL=TaskProgressStageService.js.map